import React from 'react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useStyles } from './TabList.styles';
import { IDealerLocatorLabels } from 'interfaces/dealerLocator';
import { useTheme } from '@mui/material';

export interface ITabList {
  changeFunction: (event: React.ChangeEvent<{}>, newValue: string) => void;
  labels: IDealerLocatorLabels;
  value: string;
}
export function TabList({ labels, value, changeFunction }: ITabList) {
  const classes = useStyles();
  const theme = useTheme();
  const isHondaTheme = theme.themeName === 'honda';
  return (
    <AppBar className={`${classes.root} tab-list`} position="static">
      <Tabs
        classes={{ indicator: classes.tabIndicator }}
        indicatorColor={'secondary'}
        value={value}
        onChange={changeFunction}
        variant={isHondaTheme ? undefined : 'fullWidth'}
      >
        <Tab
          className={`${classes.tab} tab ${
            isHondaTheme ? 'atm-caption-7' : 'acr-label-3'
          }`}
          value={labels.tabListView}
          label={labels.tabListView}
          key={labels.tabListView}
          wrapped
          disableRipple
        />
        <Tab
          className={`${classes.tab} tab ${
            isHondaTheme ? 'atm-caption-7' : 'acr-label-3'
          }`}
          value={labels.tabMapView}
          label={labels.tabMapView}
          key={labels.tabMapView}
          wrapped
          disableRipple
        />
      </Tabs>
    </AppBar>
  );
}
